import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Layout, SubscriptionPlanCard } from '../../../components';
import { axiosInstance } from '../../../helpers';

function SubscriptionPlans() {
  const router = useRouter();
  const axiosService = axiosInstance();
  const [plans, setPlans] = useState([]);

  async function fetchSubscriptionPlan() {
    try {
      const { data } = await axiosService.get(
        `plans/customer/${router.query.alias}`
      );

      setPlans(data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchSubscriptionPlan();
  }, []);

  return (
    <Layout title="Subscription plans | slotit.io">
      <div className="max-w-7xl">
        <div>
          <div className="mb-4">
            <h3 className="leading-6 text-gray-500">
              <span className="text-2xl font-medium text-gray-900">
                {plans[0]?.company?.name}
              </span>{' '}
              subscription plans
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              These are the plans the company offers.
            </p>
          </div>
          <div className="space-y-4 sm:space-y-0 sm:grid lg:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-3">
            {plans
              ?.sort((a, b) =>
                parseInt(a.price) > parseInt(b.price)
                  ? 1
                  : parseInt(b.price) > parseInt(a.price)
                  ? -1
                  : 0
              )
              ?.map((plan) => (
                <SubscriptionPlanCard plan={plan} key={plan.id} />
              ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export async function getServerSideProps(context) {
  return {
    props: {},
  };
}

export default SubscriptionPlans;
